import React from "react";
import { Input } from "antd";
import PropTypes from "prop-types";
import { just_digit } from "../../../constant/helper";

const CustomJustDigits = (props) => {
  const { onChange, value, ...otherProps } = props;

  return (
    <Input
      value={value}
      onKeyPress={(e) => {
        const pressedKey = String.fromCharCode(
          !e.charCode ? e.which : e.charCode
        );
        if (!just_digit(pressedKey)) {
          e.preventDefault();
          return false;
        }
      }}
      onChange={onChange}
      {...otherProps}
    />
  );
};

CustomJustDigits.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default CustomJustDigits;
